/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';

import { apiConfig } from '@pages/VendingMachinePage/config/api.config';
import { productConfig } from '@pages/VendingMachinePage/config/product.config';
import { CAPSULES_QUERY } from '@pages/VendingMachinePage/apis/graphql';

export interface IShelvesPluginMethods extends IPluginMethodMap {
  getShelves(args?: any): Promise<any>;
}

export class ShelvesPlugin implements IAgentPlugin {
  readonly methods: IShelvesPluginMethods;
  private products: any[];

  constructor() {
    this.methods = {
      getShelves: this.getShelves.bind(this),
    };
    this.products = [...productConfig.products];
  }

  async getShelves(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.findCapsules();
    await this.findPosts();
    return {
      products: this.formatProducts(this.products),
    };
  }
  //Graphql Query example
  async findCapsules(args?: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.spacex_gql.url);
      // const token = getToken();
      const token = null;
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client.query(CAPSULES_QUERY, { limit: 5 }).toPromise();
      log.log('result of capsules=', res?.data?.capsules);
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }

  //Rest API Example
  async findPosts(args?: any) {
    try {
      let sttp = Sttp.withBaseUrl(apiConfig.jsonplaceholder_rest.url);
      //  sttp =  sttp
      //     .withQueryParams({ page: 3 })
      //     .withHeaders({ 'X-API-Token': 123 })
      //     .withPayload({ name: 'Supercharge' })
      // const res = await sttp.post(`/your_url`);

      const res = await sttp.get(`/posts`);
      if (res?.isError()) {
        log.error(
          `error in post status=${res.status()} statusText=${res.statusText()}`
        );
      }
      log.log('result of post=', res.data());
    } catch (err: any) {
      log.error('error in post=', err?.message);
      throw err;
    }
  }

  private formatProducts(products: any) {
    return products.map((product: any) => product);
  }
}
